import BankCategoryService from '@/services/banking/BankCategoryService';

const bankCategoryService = new BankCategoryService();

export const getAllMappings = async({ commit }: {commit: Function}) => {
    commit('isFetching', true);
    try {
        console.log('[bankCategory/getAllMappings] Fetching mappings...');
        const mappings = await bankCategoryService.getAllMappings();
        console.log('[bankCategory/getAllMappings] Received mappings:', mappings);
        commit('allMappings', mappings);
    } catch (error) {
        console.error('[bankCategory/getAllMappings] Error fetching mappings:', error);
        commit('allMappings', []);
        throw error;
    } finally {
        commit('isFetching', false);
    }
}

export const getAllCategories = async({ commit }: {commit: Function}) => {
    const categories = await bankCategoryService.getAllCategories();
    commit('allCategories', categories);
}

export const getOrgsByCategory = async({ commit }: {commit: Function}, category: string) => {
    return await bankCategoryService.getOrgsByCategory(category);
}

export const getCategoriesByOrg = async({ commit }: {commit: Function}, orgId: string) => {
    return await bankCategoryService.getCategoriesByOrg(orgId);
}

export const createMapping = async({ commit }: {commit: Function}, payload: { category: string, orgId: string }) => {
    await bankCategoryService.createMapping(payload.category, payload.orgId);
}

export const deleteMapping = async({ commit }: {commit: Function}, payload: { category: string, orgId: string }) => {
    await bankCategoryService.deleteMapping(payload.category, payload.orgId);
}
